module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/customer/customer-09-a6cf4db702bc89d216d24eb77082cc5a.jpg";